import Box from '@mui/material/Box';

interface Props {
    audios: string[];
}

const ShowNoteAudios = ({ audios }: Props) => (
    <Box
        sx={{
            display: 'grid',
            px: 1,
            gap: 1,
        }}
    >
        {audios.map((urlToDownload) => (
            <Box
                component='audio'
                controls
                key={urlToDownload}
                src={urlToDownload}
                sx={{
                    width: '100%',
                    height: 40,
                }}
            />
        ))}
    </Box>
);
export default ShowNoteAudios;
